/**
 * Pluralizes a word based on a count.
 * 
 * @param {number} count - The count to determine pluralization
 * @param {string} singular - The singular form of the word
 * @param {string} plural - The plural form of the word (default: singular + 's')
 * @returns {string} - The formatted string with count and properly pluralized word
 */
export const pluralize = (count, singular, plural = `${singular}s`) => {
  const word = count === 1 ? singular : plural;
  return `${count} ${word}`;
};

/**
 * Returns the properly pluralized form of a word based on a count without the count itself.
 * 
 * @param {number} count - The count to determine pluralization
 * @param {string} singular - The singular form of the word
 * @param {string} plural - The plural form of the word (default: singular + 's')
 * @returns {string} - The properly pluralized word only
 */
export const pluralizeWord = (count, singular, plural = `${singular}s`) => {
  return count === 1 ? singular : plural;
}; 